import { render, staticRenderFns } from "./intequerydashboard.vue?vue&type=template&id=b4ee6d3a"
import script from "./intequerydashboard.vue?vue&type=script&lang=js"
export * from "./intequerydashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports